// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"af70f615","453":"6c690edf","531":"fb913118","550":"a1ea0256","855":"daa3cb86"}[chunkId] + ".chunk.js";
};